import { render, staticRenderFns } from "./TableBuilderPowerBiReport.vue?vue&type=template&id=306dc254&scoped=true"
import script from "./TableBuilderPowerBiReport.vue?vue&type=script&lang=js"
export * from "./TableBuilderPowerBiReport.vue?vue&type=script&lang=js"
import style0 from "./TableBuilderPowerBiReport.vue?vue&type=style&index=0&id=306dc254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306dc254",
  null
  
)

export default component.exports